// Wrap everything in an IIFE to avoid variable scope issues
(function() {
  // Constants
  const API_KEY = 'c816f700.0938efb8d12babafb768a79520c724012324d6ca8884ede35e8b5deb';
  const API_ENDPOINT = 'https://www.consuelohq.com/api/try-on';
  const FASHION_FACTS = [
    "Did you know? The first fashion magazine was published in Germany in 1586!",
    "High heels were originally worn by Persian horsemen in the 10th century to keep their feet in stirrups.",
    "The concept of 'ready-to-wear' clothing didn't exist until the Industrial Revolution in the 19th century.",
    "Buttons were originally used as decorative ornaments rather than fasteners - buttonholes weren't invented until the 13th century.",
    "The little black dress became iconic after Coco Chanel published a simple calf-length black dress in Vogue in 1926.",
    "The word 'denim' comes from the French phrase 'serge de Nîmes', referring to the city where the fabric was first made.",
    "Before the 1920s, pink was considered a masculine color while blue was viewed as more feminine."
  ];

 function normalizeCategory(category) {
  const validCategories = ['tops', 'bottoms', 'one-pieces'];
  
  if (category === null || category === undefined) {
    console.log(`Null/undefined category, defaulting to "tops"`);
    return 'tops';
  }
  
  const categoryStr = String(category).toLowerCase().trim();
  
  if (validCategories.includes(categoryStr)) {
    console.log(`Category "${categoryStr}" is already valid`);
    return categoryStr;
  }
  
  const categoryMappings = {
    // One-pieces
    'dress': 'one-pieces',
    'dresses': 'one-pieces',
    'jumpsuit': 'one-pieces',
    'romper': 'one-pieces',
    'one piece': 'one-pieces',
    'onepiece': 'one-pieces',
    'one-piece': 'one-pieces',
    'bodysuit': 'one-pieces',
    'overall': 'one-pieces',
    'overalls': 'one-pieces',
    'coverall': 'one-pieces',
    'coveralls': 'one-pieces',
    'gown': 'one-pieces',
    'suit': 'one-pieces',
    
    // Tops
    'top': 'tops',
    'shirt': 'tops',
    'shirts': 'tops',
    'blouse': 'tops',
    'tshirt': 'tops',
    't-shirt': 'tops',
    't shirt': 'tops',
    'tee': 'tops',
    'upper_body': 'tops',
    'jacket': 'tops',
    'hoodie': 'tops',
    'sweater': 'tops',
    'sweatshirt': 'tops',
    'vest': 'tops',
    'coat': 'tops',
    'blazer': 'tops',
    'cardigan': 'tops',
    'polo': 'tops',
    'tank': 'tops',
    'tanktop': 'tops',
    'tank top': 'tops',
    'jersey': 'tops',
    'pullover': 'tops',
    'tunic': 'tops',
    'bra': 'tops',
    'sports bra': 'tops',
    'crop': 'tops',
    'crop top': 'tops',
    'turtle neck': 'tops',
    'turtleneck': 'tops',
    'mock neck': 'tops',
    'mockneck': 'tops',
    
    // Equestrian tops
    'show coat': 'tops',
    'show jacket': 'tops',
    'riding jacket': 'tops',
    'competition coat': 'tops',
    'hunt coat': 'tops',
    'shadbelly': 'tops',
    'dressage coat': 'tops',
    'riding vest': 'tops',
    'ratcatcher': 'tops',
    'stock tie': 'tops',
    'sun shirt': 'tops',
    'technical shirt': 'tops',
    'show shirt': 'tops',
    'equestrian shirt': 'tops',
    'riding shirt': 'tops',
    
    // Bottoms
    'bottom': 'bottoms',
    'bottoms': 'bottoms',
    'pants': 'bottoms',
    'pant': 'bottoms',
    'lower_body': 'bottoms',
    'jeans': 'bottoms',
    'shorts': 'bottoms',
    'skirt': 'bottoms',
    'skirts': 'bottoms',
    'leggings': 'bottoms',
    'trouser': 'bottoms',
    'trousers': 'bottoms',
    'slacks': 'bottoms',
    'capri': 'bottoms',
    'capris': 'bottoms',
    'jean': 'bottoms',
    'jogger': 'bottoms',
    'joggers': 'bottoms',
    'sweatpant': 'bottoms',
    'sweatpants': 'bottoms',
    'track pant': 'bottoms',
    'track pants': 'bottoms',
    'culottes': 'bottoms',
    'chino': 'bottoms',
    'chinos': 'bottoms',
    'cargo': 'bottoms',
    'cargo pants': 'bottoms',
    
    // Equestrian bottoms
    'breeches': 'bottoms',
    'breech': 'bottoms',
    'jodhpurs': 'bottoms',
    'jodhpur': 'bottoms',
    'riding pants': 'bottoms',
    'riding tights': 'bottoms',
    'full seat': 'bottoms',
    'knee patch': 'bottoms',
    'schooling tight': 'bottoms',
    'schooling tights': 'bottoms',
    'riding jean': 'bottoms',
    'riding jeans': 'bottoms',
    'show breeches': 'bottoms'
  };
  
  // Direct mapping - exact match
  if (categoryMappings[categoryStr]) {
    console.log(`Mapped category "${categoryStr}" to "${categoryMappings[categoryStr]}"`);
    return categoryMappings[categoryStr];
  }
  
  // Partial matching - check for keywords in product name/description
  for (const [term, mappedCategory] of Object.entries(categoryMappings)) {
    if (categoryStr.includes(term)) {
      console.log(`Partial match: "${categoryStr}" contains "${term}" → mapped to "${mappedCategory}"`);
      return mappedCategory;
    }
  }
  
  // Advanced pattern matching for equestrian terminology
  if (/breech|jodhpur|riding\s+pant|equestrian\s+pant/i.test(categoryStr)) {
    console.log(`Pattern match: "${categoryStr}" matches equestrian bottoms pattern → mapped to "bottoms"`);
    return 'bottoms';
  }
  
  if (/show\s+coat|riding\s+jacket|shadbelly|hunt\s+coat|equestrian\s+jacket/i.test(categoryStr)) {
    console.log(`Pattern match: "${categoryStr}" matches equestrian tops pattern → mapped to "tops"`);
    return 'tops';
  }
  
  if (/jumpsuit|bodysuit|one-piece|onepiece|dress|gown|overall/i.test(categoryStr)) {
    console.log(`Pattern match: "${categoryStr}" matches one-pieces pattern → mapped to "one-pieces"`);
    return 'one-pieces';
  }
  
  // Check for plural forms that might have been missed
  const singularCheck = categoryStr.replace(/s$/, '');
  if (categoryMappings[singularCheck]) {
    console.log(`Singular form match: "${categoryStr}" → "${singularCheck}" → mapped to "${categoryMappings[singularCheck]}"`);
    return categoryMappings[singularCheck];
  }
  
  // Check for common product type indicators
  if (/shirt|top|jacket|coat|vest|hoodie|sweater|blouse|polo/i.test(categoryStr)) {
    console.log(`Pattern match: "${categoryStr}" matches tops pattern → mapped to "tops"`);
    return 'tops';
  }
  
  if (/pant|bottom|short|skirt|legging|jean|trouser/i.test(categoryStr)) {
    console.log(`Pattern match: "${categoryStr}" matches bottoms pattern → mapped to "bottoms"`);
    return 'bottoms';
  }
  
  console.log(`Unable to map category "${categoryStr}", defaulting to "tops"`);
  return 'tops';
}
  class VirtualTryOn {
    constructor(container, garmentImage, category) {
      this.container = container;
      this.garmentImage = garmentImage;
      this.category = normalizeCategory(category); // Use the function defined outside
      this.options = {
        buttonText: ''
      };
      
      // State management
      this.state = {
        screen: 'welcome',
        isLoading: false,
        error: null,
        result: null,
        userImage: null,
        userImagePreview: null,
        garmentBase64: null,
        instructionsChecked: false
      };

      // DOM elements
      this.modal = null;
      this.triggerButton = null;

      // Initialize component
      this.initialize();
    }

    // Initialization sequence
    async initialize() {
      try {
        console.log("Initializing Virtual Try-On...");
        this.addStyles();
        this.createModal();
        this.createTriggerButton();
        await this.loadGarmentImage();
        this.initializeEventListeners();
        console.log("Virtual Try-On initialized successfully");
      } catch (error) {
        console.error('Initialization failed:', error);
        this.showError('Failed to initialize virtual try-on');
      }
    }

    // State management
    setState(newState) {
      this.state = { ...this.state, ...newState };
      this.render();
    }

    // DOM creation
    createModal() {
      this.modal = document.createElement('div');
      this.modal.className = 'try-on-modal hidden';
      this.modal.innerHTML = `
        <div class="modal-content">
          <button class="close-button">&times;</button>
          <div class="modal-body"></div>
        </div>
      `;
      document.body.appendChild(this.modal);
    }

    createTriggerButton() {
      // First, clear any existing button
      this.container.innerHTML = '';
      
      // Create the button
      const button = document.createElement('button');
      button.className = 'try-on-button';
      button.textContent = this.options.buttonText;
      button.addEventListener('click', () => this.openModal());
      
      // Add button to container
      this.container.appendChild(button);
      console.log("Created try-on button in container");
    }

    // Add styles to document
    addStyles() {
      const styles = `
    /* Base variables */
    :root {
      --primary: #6366f1;
      --primary-dark: #4f46e5;
      --secondary: #3b82f6;
      --gray-100: #f3f4f6;
      --gray-200: #e5e7eb;
      --gray-300: #d1d5db;
      --gray-600: #4b5563;
      --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
      --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1);
    }
    
    /* Try-on button */
    .try-on-button {
      display: inline-block;
      width: 100%;
      padding: 10px;
      background-color: var(--primary);
      color: white;
      border: none;
      border-radius: 4px;
      margin-bottom: 10px;
      cursor: pointer;
      font-weight: bold;
      text-align: center;
    }
    
    .try-on-button:hover {
      background-color: var(--primary-dark);
    }
    .tips-screen {
  padding: 16px 0;
}

.tips-screen h3 {
  text-align: center;
  margin-bottom: 20px;
  color: var(--primary);
}

.tips-content {
  margin-bottom: 24px;
}

.tip-item {
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--gray-200);
}

.tip-item:last-child {
  border-bottom: none;
}

.tip-item h4 {
  margin-bottom: 8px;
  color: var(--gray-600);
}

.tip-item p {
  color: var(--gray-600);
  font-size: 14px;
  line-height: 1.5;
}

.tips-button {
  display: block;
  width: 100%;
  padding: 8px 16px;
  background-color: white;
  color: var(--primary);
  border: 1px solid var(--primary);
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  margin-top: 12px;
  text-align: center;
}

.tips-button:hover {
  background-color: var(--gray-100);
}

.back-button {
  width: 100%;
  padding: 10px 16px;
  background-color: var(--primary);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  margin-top: 16px;
}

.back-button:hover {
  background-color: var(--primary-dark);
}
    
    /* Modal */
    .try-on-modal {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.7);
      z-index: 9999;
      display: flex;
      justify-content: center;
      align-items: center;
      opacity: 0;
      transition: opacity 0.3s ease;
      padding: 1rem;
    }
    
    .try-on-modal.active {
      opacity: 1;
    }
    
    .try-on-modal.hidden {
      display: none;
    }
    
    .modal-content {
      background: white;
      border-radius: 16px;
      padding: 24px;
      width: 90%;
      max-width: 480px;
      position: relative;
      transform: translateY(20px);
      opacity: 0;
      transition: all 0.3s ease;
      max-height: 85vh;
      overflow-y: auto;
    }
    
    .try-on-modal.active .modal-content {
      transform: translateY(0);
      opacity: 1;
    }
    
    /* Close Button */
    .close-button {
      position: absolute;
      top: 16px;
      right: 16px;
      background: var(--gray-100);
      border: none;
      border-radius: 50%;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.2s ease;
      color: var(--gray-600);
      font-size: 20px;
      z-index: 10;
    }
    
    /* Additional styles for modal internals */
    .error {
      color: #dc2626;
      background: #fef2f2;
      padding: 12px;
      border-radius: 8px;
      margin: 12px 0;
      font-size: 14px;
    }
    
    /* NEW STYLES FOR REACT-LIKE UI */
    .icon-container {
      display: flex;
      justify-content: center;
      margin-bottom: 16px;
    }
    
    .icon-svg {
      height: 48px;
      width: 48px;
      color: var(--primary);
    }
    
    .welcome-text {
      text-align: center;
      margin-bottom: 20px;
      font-size: 14px;
      color: var(--gray-600);
    }
    
    .tips-container {
      margin-top: 16px;
      animation: fadeInUp 0.5s ease;
    }
    
    .tips-header {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 12px;
    }
    
    .tips-content {
      background-color: #F9FAFB;
      border: 1px solid #E5E7EB;
      border-radius: 8px;
      padding: 16px;
      margin-bottom: 16px;
    }
    
    .tip-item {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      margin-top: 8px;
    }
    
    .checkbox-container {
      display: flex;
      align-items: center;
      gap: 12px;
      background-color: white;
      padding: 16px;
      border: 1px solid #E5E7EB;
      border-radius: 8px;
      margin: 16px 0;
    }
    
    .upload-area {
      border: 2px dashed #D1D5DB;
      border-radius: 8px;
      padding: 16px;
      margin-bottom: 16px;
    }
    
    .upload-button {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 160px;
      width: 100%;
      background-color: transparent;
      border: 1px solid #D1D5DB;
      border-radius: 8px;
      cursor: pointer;
      color: #6B7280;
      margin-top: 16px;
    }
    
    .upload-button:hover {
      background-color: #F9FAFB;
    }
    
    .process-button {
      width: 100%;
      padding: 10px 16px;
      background-color: var(--primary);
      color: white;
      border: none;
      border-radius: 6px;
      cursor: pointer;
      font-weight: 500;
      font-size: 14px;
      margin-top: 16px;
    }
    
    .process-button:hover {
      background-color: var(--primary-dark);
    }
    
    .process-button:disabled {
      background-color: #9CA3AF;
      cursor: not-allowed;
    }
    
    .image-preview {
      position: relative;
      display: inline-block;
      margin-bottom: 16px;
    }
    
    .image-preview img {
      max-height: 384px;
      width: auto;
      border-radius: 8px;
    }
    
    .remove-button {
      position: absolute;
      top: 8px;
      right: 8px;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background-color: #EF4444;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding: 0;
      border: none;
    }
    
    .loading-container {
      margin-top: 16px;
    }
    
    .loading-spinner {
      width: 32px;
      height: 32px;
      border: 3px solid rgba(0, 0, 0, 0.1);
      border-radius: 50%;
      border-top-color: var(--primary);
      animation: spin 1s linear infinite;
      margin-bottom: 16px;
    }
    
    .fact-container {
      margin: 16px 0;
      background-color: #F9FAFB;
      padding: 12px;
      border-radius: 8px;
      border: 1px solid #E5E7EB;
    }
    
    .fashion-fact {
      font-size: 14px;
      color: #4B5563;
    }
    
    .result-container {
      margin: 16px 0;
    }
    
    .result-container img {
      max-height: 384px;
      width: auto;
      border-radius: 8px;
    }
    
    .try-again-button {
      width: 100%;
      padding: 10px 16px;
      background-color: var(--primary);
      color: white;
      border: none;
      border-radius: 6px;
      cursor: pointer;
      font-weight: 500;
      font-size: 14px;
      margin-top: 16px;
    }
    
    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    
    @keyframes spin {
      100% { transform: rotate(360deg); }
    }
  `;
  
      // Only add styles if they're not already added
      if (!document.getElementById('virtual-try-on-styles')) {
        const styleSheet = document.createElement('style');
        styleSheet.id = 'virtual-try-on-styles';
        styleSheet.textContent = styles;
        document.head.appendChild(styleSheet);
      }
    }

    // Image handling
   async loadGarmentImage() {
      try {
        if (!this.garmentImage) {
          throw new Error('No garment image provided');
        }
    
        // If it's already a base64 string
        if (this.garmentImage.startsWith('data:image')) {
          this.state.garmentBase64 = this.garmentImage;
          return;
        }
    
        // If it's a URL, fetch and convert to base64
        const response = await fetch(this.garmentImage.replace('http://', 'https://'), {
          headers: {
            'Origin': window.location.origin
          }
        });
        
        const blob = await response.blob();
        
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            this.state.garmentBase64 = reader.result;
            console.log('Garment image loaded successfully');
            resolve();
          };
          reader.onerror = () => {
            reject(new Error('Failed to convert garment image'));
          };
          reader.readAsDataURL(blob);
        });
    
      } catch (err) {
        console.error('Error loading garment image:', err);
        this.setState({ error: 'Error loading product image' });
        throw err;
      }
    }

    // Modal interactions
    openModal() {
      this.modal.classList.remove('hidden');
      setTimeout(() => this.modal.classList.add('active'), 10);
      this.render();
    }

    closeModal() {
      this.modal.classList.remove('active');
      setTimeout(() => this.modal.classList.add('hidden'), 300);
    }

    // Event handling
    initializeEventListeners() {
      // Close modal interactions
      const closeButton = this.modal.querySelector('.close-button');
      if (closeButton) {
        closeButton.addEventListener('click', () => this.closeModal());
      }
      
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) this.closeModal();
      });

      // We'll add more event listeners during render
    }

    // Image processing
   async handleImageUpload(file) {
  if (!file) return;

  this.setState({ isLoading: true });
  
  try {
    const userImagePreview = await this.readFileAsDataURL(file);
    console.log('Image loaded, setting preview state');
    this.setState({
      userImagePreview,
      userImage: file,
      isLoading: false,
      screen: 'preview'  // Make sure this is set to 'preview'
    });
    console.log('New state after image upload:', this.state);
  } catch (error) {
    console.error('Error processing image:', error);
    this.setState({
      error: 'Failed to process image',
      isLoading: false
    });
  }
}

    readFileAsDataURL(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    }

    // Core try-on functionality
   
async validateGarmentImage() {
  if (!this.state.garmentBase64) {
    throw new Error('No garment image available');
  }

  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      // Check if image dimensions are appropriate (most product images are roughly square or portrait)
      const aspectRatio = img.width / img.height;
      
      // Log for debugging
      console.log(`Garment image dimensions: ${img.width}x${img.height}, aspect ratio: ${aspectRatio.toFixed(2)}`);
      
      // Create canvas to analyze image
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      // Use a smaller size for analysis to improve performance
      const analysisWidth = 300;
      const analysisHeight = 300;
      
      canvas.width = analysisWidth;
      canvas.height = analysisHeight;
      
      // Draw the image to the canvas, scaling it down
      ctx.drawImage(img, 0, 0, analysisWidth, analysisHeight);
      
      // Basic image analysis - check if image has transparent background
      // Product images often have transparent or white backgrounds
      const imageData = ctx.getImageData(0, 0, analysisWidth, analysisHeight);
      const data = imageData.data;
      
      // Check corners of the image for white/transparent background
      // This is a simple heuristic but can help identify product images
      const corners = [
        {x: 5, y: 5},                                  // top-left
        {x: analysisWidth - 5, y: 5},                  // top-right
        {x: 5, y: analysisHeight - 5},                 // bottom-left
        {x: analysisWidth - 5, y: analysisHeight - 5}  // bottom-right
      ];
      
      let whiteCornerCount = 0;
      corners.forEach(corner => {
        const pixelIndex = (corner.y * analysisWidth + corner.x) * 4;
        const r = data[pixelIndex];
        const g = data[pixelIndex + 1];
        const b = data[pixelIndex + 2];
        const a = data[pixelIndex + 3];
        
        // Check if pixel is white or transparent
        if ((r > 240 && g > 240 && b > 240) || a < 50) {
          whiteCornerCount++;
        }
      });
      
      // Analyze edge detection to see if there's a clear product outline
      // This would require more complex algorithms, but here's a simplified version
      let edgePixelCount = 0;
      const edgeThreshold = 30; // Pixel difference threshold to consider an edge
      
      for (let y = 1; y < analysisHeight - 1; y++) {
        for (let x = 1; x < analysisWidth - 1; x++) {
          const currentPixel = (y * analysisWidth + x) * 4;
          const rightPixel = (y * analysisWidth + (x + 1)) * 4;
          
          // Simple horizontal edge detection
          const rDiff = Math.abs(data[currentPixel] - data[rightPixel]);
          const gDiff = Math.abs(data[currentPixel + 1] - data[rightPixel + 1]);
          const bDiff = Math.abs(data[currentPixel + 2] - data[rightPixel + 2]);
          
          if (rDiff > edgeThreshold || gDiff > edgeThreshold || bDiff > edgeThreshold) {
            edgePixelCount++;
          }
        }
      }
      
      // Calculate edge density (ratio of edge pixels to total pixels)
      const edgeDensity = edgePixelCount / (analysisWidth * analysisHeight);
      console.log(`Edge density: ${edgeDensity.toFixed(4)}`);
      
      // Make a determination based on our heuristics
      let isLikelyProductImage = false;
      
      // Product images often have:
      // 1. White/transparent corners (background)
      // 2. Clear edges (product outline)
      // 3. Reasonable aspect ratio (not extremely wide/tall)
      if (
        (whiteCornerCount >= 3) &&
        (edgeDensity > 0.01 && edgeDensity < 0.1) && 
        (aspectRatio > 0.5 && aspectRatio < 2.0)
      ) {
        isLikelyProductImage = true;
      }
      
      console.log(`Image analysis result: ${isLikelyProductImage ? 'Product image' : 'Not clearly a product image'}`);
      
      // If not likely a product image, we might need to pre-process it
      if (!isLikelyProductImage) {
        console.log('Attempting to improve garment image...');
        // Try to extract the product from the background
        // This is a simplified approach - real solutions would use more sophisticated methods
        
        // For now, let's just try to crop to center and add white margin
        const cropWidth = Math.min(img.width, img.height * 0.8);
        const cropHeight = Math.min(img.height, img.width * 0.8);
        const cropX = (img.width - cropWidth) / 2;
        const cropY = (img.height - cropHeight) / 2;
        
        // Create a new canvas with padding
        const processedCanvas = document.createElement('canvas');
        const padding = 20; // 20px white padding
        processedCanvas.width = cropWidth + (padding * 2);
        processedCanvas.height = cropHeight + (padding * 2);
        
        const processedCtx = processedCanvas.getContext('2d');
        
        // Fill with white background
        processedCtx.fillStyle = 'white';
        processedCtx.fillRect(0, 0, processedCanvas.width, processedCanvas.height);
        
        // Draw the cropped image
        processedCtx.drawImage(
          img,
          cropX, cropY, cropWidth, cropHeight,
          padding, padding, cropWidth, cropHeight
        );
        
        // Convert back to base64
        const processedImageBase64 = processedCanvas.toDataURL('image/jpeg', 0.95);
        
        console.log('Created processed version of garment image');
        
        // Return both versions for the client to try
        resolve({
          original: this.state.garmentBase64,
          processed: processedImageBase64,
          useProcessed: true
        });
      } else {
        // Image looks good, use as is
        resolve({
          original: this.state.garmentBase64,
          processed: null,
          useProcessed: false
        });
      }
    };
    
    img.onerror = () => {
      reject(new Error('Failed to analyze garment image'));
    };
    
    img.src = this.state.garmentBase64;
  });
}

// Add this function to preprocess images before sending to the API
async preprocessImage(base64Image) {
  return new Promise((resolve, reject) => {
    try {
      console.log('Preprocessing image to optimize size...');
      
      // Create an image element to load the base64 data
      const img = new Image();
      img.onload = () => {
        // Always resize images to ensure reasonable sizes
        // 1200px is a good max size that balances quality and file size
        let targetWidth = img.width;
        let targetHeight = img.height;
        const MAX_DIMENSION = 1200;
        
        // If either dimension exceeds our max, resize proportionally
        if (img.width > MAX_DIMENSION || img.height > MAX_DIMENSION) {
          console.log(`Image dimensions (${img.width}x${img.height}) exceed limit, resizing...`);
          
          if (img.width >= img.height) {
            // Landscape or square image
            targetWidth = MAX_DIMENSION;
            targetHeight = Math.round(img.height * (MAX_DIMENSION / img.width));
          } else {
            // Portrait image
            targetHeight = MAX_DIMENSION;
            targetWidth = Math.round(img.width * (MAX_DIMENSION / img.height));
          }
          
          console.log(`New dimensions: ${targetWidth}x${targetHeight}`);
        }
        
        // Create canvas for resizing
        const canvas = document.createElement('canvas');
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        
        // Draw image to canvas with smoothing
        const ctx = canvas.getContext('2d');
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
        
        // Use multiple compression levels if needed
        let quality = 0.85; // Start with 85% quality
        let optimizedBase64 = canvas.toDataURL('image/jpeg', quality);
        
        // If still too large (over ~1MB), compress further
        if (optimizedBase64.length > 1000000) {
          quality = 0.65; // Reduce to 65% quality
          optimizedBase64 = canvas.toDataURL('image/jpeg', quality);
          console.log('Image still large, further reducing quality to 65%');
        }
        
        // Log size reduction
        const originalSize = Math.round(base64Image.length / 1024);
        const newSize = Math.round(optimizedBase64.length / 1024);
        const reduction = Math.round(((originalSize - newSize) / originalSize) * 100);
        
        console.log(`Image optimized: ${originalSize}KB → ${newSize}KB (${reduction}% reduction)`);
        
        resolve(optimizedBase64);
      };
      
      img.onerror = () => {
        console.error('Error loading image for preprocessing');
        // Return original if preprocessing fails
        resolve(base64Image);
      };
      
      img.src = base64Image;
    } catch (error) {
      console.error('Image preprocessing failed:', error);
      // Return original if preprocessing fails
      resolve(base64Image);
    }
  });
}

async processTryOn() {
  if (!this.state.userImagePreview || !this.state.garmentBase64) {
    this.setState({ error: 'Missing required images. Please upload your photo and try again.' });
    return;
  }

  this.setState({ isLoading: true, screen: 'loading' });

  try {
    // Preprocess the user image to reduce size
    console.log('Preprocessing user image...');
    const optimizedUserImage = await this.preprocessImage(this.state.userImagePreview);
    
    // Validate and potentially improve the garment image
    console.log('Validating garment image...');
    const imageValidation = await this.validateGarmentImage();
    
    // Choose which image to use
    const garmentToUse = imageValidation.useProcessed && imageValidation.processed 
      ? imageValidation.processed 
      : imageValidation.original;
    
    console.log(`Using ${imageValidation.useProcessed ? 'processed' : 'original'} garment image`);

    // Create payload
    const payload = {
      model_image: optimizedUserImage,
      garment_image: garmentToUse,
      category: this.category,
      mode: 'balanced',
      num_samples: 1
    };

    console.log('Sending try-on request with category:', this.category);

    // Send API request
    const response = await fetch(API_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${API_KEY}`
      },
      body: JSON.stringify(payload)
    }).catch(error => {
      console.error('Fetch error:', error);
      // Check for specific error types
      if (error.message && error.message.includes('413')) {
        throw new Error('Your photo is too large. Please try using a smaller image or reducing its resolution.');
      } else {
        throw new Error('Unable to connect to the try-on service. Please check your internet connection and try again.');
      }
    });

    if (!response.ok) {
      const errorText = await response.text();
      let errorMessage = 'The virtual try-on service is currently unavailable. Please try again later.';
      
      try {
        // Try to parse error JSON
        const errorData = JSON.parse(errorText);
        
        if (errorData.error) {
          // Extract more specific error message if available
          if (typeof errorData.error === 'object' && errorData.error.message) {
            errorMessage = errorData.error.message;
          } else if (typeof errorData.error === 'string') {
            errorMessage = errorData.error;
          }
        }
      } catch (e) {
        // If JSON parsing fails, use the error text or default message
        errorMessage = errorText || errorMessage;
      }
      
      throw new Error(errorMessage);
    }
    
    const result = await response.json();
    
    // Check if we got a prediction ID
    if (!result.id) {
      throw new Error('The try-on service didn\'t respond correctly. Please try again later.');
    }
    
    // Poll for results
    this.pollForResults(result.id);
    
  } catch (error) {
    console.error('Try-on processing error:', error);
    this.setState({
      error: error.message || 'Failed to process virtual try-on',
      isLoading: false,
      screen: 'error'
    });
  }
}
    // Poll for results
  async pollForResults(predictionId) {
  try {
    console.log(`Polling for results with ID: ${predictionId}`);
    
    // Define polling interval
    const pollInterval = 3000; // 3 seconds
    const maxPolls = 20; // Max 1 minute polling
    
    let pollCount = 0;
    const checkStatus = async () => {
      if (pollCount >= maxPolls) {
        this.setState({
          error: 'Processing is taking longer than expected. Please try again.',
          isLoading: false,
          screen: 'error' // Add explicit screen change
        });
        return; // Return to exit the function instead of throwing
      }
      
      pollCount++;
      console.log(`Poll attempt ${pollCount} for ID: ${predictionId}`);
      
      try { // Add try/catch block inside the checkStatus function
        // Request status
        const response = await fetch(`${API_ENDPOINT}/status/${predictionId}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${API_KEY}`
          }
        });
        
        if (!response.ok) {
          this.setState({
            error: 'Status check failed. Please try again later.',
            isLoading: false,
            screen: 'error' // Add explicit screen change
          });
          return; // Return instead of throwing
        }
        
        const statusData = await response.json();
        console.log(`Poll result: status = ${statusData.status}`);
        
        // Check status
        if (statusData.status === 'completed') {
          // We have results!
          console.log('Processing completed, results received');
          this.setState({
            result: statusData,
            isLoading: false,
            screen: 'results'
          });
        } else if (statusData.status === 'failed') {
          // Parse error type from FASHN API
          let errorMessage = 'Processing failed. Please try again.';
          
          if (statusData.error) {
            const errorType = statusData.error.name || '';
            
            // Customize user-friendly messages based on error type
            switch(errorType) {
              case 'ImageLoadError':
                errorMessage = 'Failed to process the garment image. Please try with a clearer product image.';
                break;
              case 'PhotoTypeError':
                errorMessage = 'Could not identify the garment in the image. Please use a product image with a simple background.';
                break;
              case 'PoseError':
                errorMessage = 'Could not detect a person in your photo. Please ensure your full body is visible.';
                break;
              case 'NSFWError':
                errorMessage = 'We detected content that may not meet our guidelines. Please try again with a different photo.';
                break;
              default:
                // Use the API provided message if available
                errorMessage = statusData.error.message || errorMessage;
            }
          }
          
          // Update state directly instead of throwing
          this.setState({
            error: errorMessage,
            isLoading: false,
            screen: 'error' // Add explicit screen change
          });
          return; // Return instead of throwing
        } else {
          // Still processing, schedule another poll
          console.log(`Still processing, scheduling next poll in ${pollInterval}ms`);
          setTimeout(checkStatus, pollInterval);
        }
      } catch (innerError) {
        // Handle errors in the checkStatus function
        console.error('Error during status check:', innerError);
        this.setState({
          error: 'Failed to check processing status. Please try again later.',
          isLoading: false,
          screen: 'error' // Add explicit screen change
        });
      }
    };
    
    // Start polling
    setTimeout(checkStatus, pollInterval);
    
  } catch (error) {
    console.error('Polling error:', error);
    this.setState({
      error: error.message || 'Failed to retrieve results',
      isLoading: false,
      screen: 'error' // Add explicit screen change
    });
  }
}
    // Rendering system
    render() {
      const body = this.modal.querySelector('.modal-body');
      if (!body) return;

      body.innerHTML = this.getScreenContent();
      
      // After rendering, attach necessary event listeners
      this.attachEventListeners();
    }
    
   attachEventListeners() {
  console.log('Attaching event listeners for screen:', this.state.screen);
     const tryAgainButton = this.modal.querySelector('.try-again-button');
  if (tryAgainButton) {
    console.log('Found try again button, attaching click listener');
    tryAgainButton.addEventListener('click', () => {
      console.log('Try again button clicked');
      // Clear error state and return to welcome screen
      this.setState({ 
        error: null, 
        screen: 'welcome',
        userImage: null,
        userImagePreview: null
      });
    });
  }
     if (this.state.screen === 'results') {
    const tipsButton = this.modal.querySelector('.tips-button');
    if (tipsButton) {
      tipsButton.addEventListener('click', () => {
        console.log('Tips button clicked');
        this.setState({ screen: 'tips' });
      });
    }
  }
  
  // Handle back button on tips screen
  if (this.state.screen === 'tips') {
    const backButton = this.modal.querySelector('.back-button');
    if (backButton) {
      backButton.addEventListener('click', () => {
        console.log('Back button clicked');
        this.setState({ screen: 'results' });
      });
    }
  }
  
  if (this.state.screen === 'upload') {
    const fileInput = this.modal.querySelector('#user-image-upload');
    if (fileInput) {
      console.log('File input found, attaching change listener');
      fileInput.addEventListener('change', (e) => {
        console.log('File input changed');
        const file = e.target.files[0];
        if (file) {
          console.log('File selected:', file.name);
          this.handleImageUpload(file);
        }
      });
    } else {
      console.error('File input element not found!');
    }
  }
  if (this.state.screen === 'welcome') {
    const checkbox = this.modal.querySelector('#instructions-check');
    if (checkbox) {
      checkbox.checked = this.state.instructionsChecked;
      checkbox.addEventListener('change', (e) => {
        this.setState({ instructionsChecked: e.target.checked });
      });
    }
    
    const startButton = this.modal.querySelector('.start-button');
    if (startButton) {
      startButton.addEventListener('click', () => {
        if (this.state.instructionsChecked) {
          this.setState({ screen: 'upload' });
        }
      });
    }
    
    const fileUpload = this.modal.querySelector('#user-image-upload');
    if (fileUpload) {
      fileUpload.addEventListener('change', (e) => {
        const file = e.target.files[0];
        this.handleImageUpload(file);
      });
    }
  } else if (this.state.screen === 'preview') {
    const removeButton = this.modal.querySelector('#remove-image-button');
    if (removeButton) {
      removeButton.addEventListener('click', () => {
        this.setState({
          userImage: null,
          userImagePreview: null,
          screen: 'upload'
        });
      });
    }
    
    const startButton = this.modal.querySelector('.process-button');
    if (startButton) {
      startButton.addEventListener('click', () => this.processTryOn());
    }
  } else if (this.state.screen === 'results') {
    const tryAgainButton = this.modal.querySelector('.try-again-button');
    if (tryAgainButton) {
      tryAgainButton.addEventListener('click', () => {
        this.setState({ screen: 'welcome' });
      });
    }
  }
}

  getScreenContent() {
  // Always prioritize error state if there is one
  if (this.state.error) {
    return this.renderErrorScreen();
  }

  if (this.state.isLoading && this.state.screen !== 'loading') {
    return this.renderLoadingScreen();
  }

  switch (this.state.screen) {
    case 'welcome':
      return this.renderWelcomeScreen();
    case 'upload':
      return this.renderUploadScreen();
    case 'preview':
      return this.renderPreviewScreen();
    case 'loading':
      return this.renderLoadingScreen();
    case 'results':
      return this.renderResultsScreen();
      case 'tips':
      return this.renderTipsScreen();
    case 'error': // Add explicit error state case
      return this.renderErrorScreen();
    default:
      console.error('Unknown screen state:', this.state.screen);
      return '<p>Screen not found</p>';
  }
}
    renderWelcomeScreen() {
  return `
    <div class="icon-container">
      <svg class="icon-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M20.38 3.46L16 2a4 4 0 01-8 0L3.62 3.46a2 2 0 00-1.34 2.23l.58 3.47a1 1 0 00.99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 002-2V10h2.15a1 1 0 00.99-.84l.58-3.47a2 2 0 00-1.34-2.23z"/>
      </svg>
    </div>
    <p class="welcome-text">
      Experience clothes virtually before you buy. Our AI-powered fitting room
      helps you see how items will look on you.
    </p>
    
    <div class="tips-container">
      <div class="tips-header">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
        <h3>Best Photo Tips</h3>
      </div>
      
      <div class="tips-content">
        <p>For the best virtual try-on results, please follow these guidelines when taking your photo:</p>
        
        <div class="tip-item">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
          <p>Clear, full-body photo</p>
        </div>
        
        <div class="tip-item">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
          <p>Simple background</p>
        </div>
        
        <div class="tip-item">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
          <p>Face forward with arms slightly away</p>
        </div>
      </div>
      
      <div class="checkbox-container">
        <input 
          type="checkbox" 
          id="instructions-check"
          ${this.state.instructionsChecked ? 'checked' : ''}
        >
        <label for="instructions-check">
          I understand these guidelines and will follow them for the best results
        </label>
      </div>
      
      <button 
        class="start-button"
        ${!this.state.instructionsChecked ? 'disabled' : ''}
      >
        Start Virtual Try-On
      </button>
    </div>
  `;
}

// 3. REPLACE YOUR renderUploadScreen() METHOD WITH THIS:

renderUploadScreen() {
  return `
    <div class="upload-area">
      <label class="upload-button">
        <input type="file" id="user-image-upload" accept="image/*" hidden>
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
          <circle cx="12" cy="13" r="4"></circle>
        </svg>
        <span style="margin-top: 12px;">Upload Your Photo</span>
        <span style="font-size: 14px; color: #9CA3AF; margin-top: 4px;">Click to browse</span>
      </label>
    </div>
  `;
}

// 4. REPLACE YOUR renderPreviewScreen() METHOD WITH THIS:

renderPreviewScreen() {
  return `
    <div class="preview-container">
      <div class="image-preview">
        <img src="${this.state.userImagePreview}" alt="Your photo">
        <button class="remove-button" id="remove-image-button">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      
      <button class="process-button">
        Try On Now
      </button>
    </div>
  `;
}

// 5. REPLACE YOUR renderLoadingScreen() METHOD WITH THIS:

renderLoadingScreen() {
  const randomFact = FASHION_FACTS[Math.floor(Math.random() * FASHION_FACTS.length)];
  
  return `
    <div class="loading-container">
      <div class="loading-spinner"></div>
      <p>Try-on AI is processing your image... This typically takes 10-13 seconds depending on your connection speed.</p>
      
      <p class="loading-message">While you wait, here's an interesting fashion fact:</p>
      <div class="fact-container">
        <p class="fashion-fact">${randomFact}</p>
      </div>
    </div>
  `;
}



renderResultsScreen() {
  if (!this.state.result || !this.state.result.output) {
    return this.renderErrorScreen('No results available');
  }
  
  const output = this.state.result.output;
  const resultImage = output[0]; // Assuming the first image is the result
  
  return `
    <div class="result-container">
      <img src="${resultImage}" alt="Try-on result">
    </div>
    
    <div class="result-actions">
      <button class="try-again-button">Try Another Photo</button>
      <button class="tips-button">Want better results?</button>
    </div>
  `;
}
renderTipsScreen() {
  return `
    <div class="tips-screen">
  <h3>Quick Tips for Better Try-On Results</h3>
  
  <div class="tips-content">
    <div class="tip-item">
      <h4>1. Show Your Full Look</h4>
      <p>Stand naturally with your arms slightly away from your sides so we can see your whole outfit!</p>
    </div>
    
    <div class="tip-item">
      <h4>2. Keep It Simple</h4>
      <p>A clean background (like a plain wall) helps our AI focus on you, not what's behind you.</p>
    </div>
    
    <div class="tip-item">
      <h4>3. Find Good Light</h4>
      <p>Even lighting makes a huge difference - natural daylight works great!</p>
    </div>
    
    <div class="tip-item">
      <h4>4. Just You</h4>
      <p>Solo photos work best - our AI gets confused when there are multiple people.</p>
    </div>
    
    <div class="tip-item">
      <h4>5. Face Forward</h4>
      <p>A straightforward pose works better than side angles or complex poses.</p>
    </div>
  
  <button class="back-button">Back to Results</button>
</div>
  `;
}
  renderErrorScreen(message) {
  const errorMessage = message || this.state.error || 'An error occurred';
  
  // Check if error is related to pose/person detection
  const isPoseError = errorMessage.toLowerCase().includes('person') || 
                      errorMessage.toLowerCase().includes('pose') ||
                      errorMessage.toLowerCase().includes('body');
  
  // Check if error is related to image size
  const isFileSizeError = errorMessage.toLowerCase().includes('too large') ||
                          errorMessage.toLowerCase().includes('size') ||
                          errorMessage.toLowerCase().includes('resolution');
  
  // Check if error is related to other image issues
  const isImageError = errorMessage.toLowerCase().includes('image') ||
                       errorMessage.toLowerCase().includes('photo');
  
  return `
    <div class="error-container">
      <h3>Oops! Something went wrong</h3>
      <p class="error-message">${errorMessage}</p>
      
      ${isFileSizeError ? `
      <div class="error-tips">
        <p>Tips for reducing image size:</p>
        <ul>
          <li>Use a photo with lower resolution</li>
          <li>Take a new photo with your device at a lower quality setting</li>
          <li>Try cropping unnecessary parts of the image</li>
        </ul>
      </div>
      ` : (isPoseError || isImageError) ? `
      <div class="error-tips">
        <p>Tips for better results:</p>
        <ul>
          <li>Take a clear, full-body photo with your entire body visible</li>
          <li>Stand against a simple background with even lighting</li>
          <li>Make sure you're the only person in the photo</li>
          <li>Stand facing forward with arms slightly away from your body</li>
        </ul>
      </div>
      ` : ''}
      
      <button class="try-again-button">
        Try Again
      </button>
    </div>
  `;
}

    // Utility methods
    showError(message) {
      this.container.innerHTML = `<div class="error">${message}</div>`;
    }
  }

  // Function to get product data
  function getProductData() {
    try {
      let product = {};
      
      // 1. Try Shopify global object
      if (window.Shopify && window.Shopify.product) {
        product = window.Shopify.product;
      }
      // 2. Try JSON-LD data
      else {
        const jsonLd = document.querySelector('script[type="application/ld+json"]');
        if (jsonLd) {
          try {
            product = JSON.parse(jsonLd.textContent);
          } catch (e) {
            console.warn("Error parsing JSON-LD:", e);
          }
        }
      }

      return {
        title: product.title || document.title,
        product_type: product.product_type || '',
        tags: Array.isArray(product.tags) ? product.tags : [],
        metafields: Array.isArray(product.metafields) ? product.metafields : []
      };

    } catch (e) {
      console.error('Error getting product data:', e);
      return {
        title: document.title,
        product_type: '',
        tags: [],
        metafields: []
      };
    }
  }

  // Ultra-reliable product image detection specifically for Shopify product pages
function getProductImageUrl() {
  console.log("Starting product image detection...");

  // 1. Look for meta tags first (most reliable for SEO purposes)
  const ogImage = document.querySelector('meta[property="og:image"]');
  if (ogImage && ogImage.content) {
    console.log("Found image in og:image meta tag:", ogImage.content);
    return ogImage.content.replace('http://', 'https://');
  }

  // 2. Try product JSON in the page (another reliable source)
  try {
    const jsonElements = document.querySelectorAll('script[type="application/json"]');
    for (const element of jsonElements) {
      try {
        const data = JSON.parse(element.textContent);
        
        // Check if this is product data
        if (data && (data.product || data.featured_image || data.images)) {
          if (data.featured_image) {
            console.log("Found image in JSON data (featured_image)");
            return data.featured_image.replace('http://', 'https://');
          }
          
          if (data.images && data.images.length > 0) {
            console.log("Found image in JSON data (images array)");
            return data.images[0].replace('http://', 'https://');
          }
          
          if (data.product && data.product.featured_image) {
            console.log("Found image in JSON data (product.featured_image)");
            return data.product.featured_image.replace('http://', 'https://');
          }
          
          if (data.product && data.product.images && data.product.images.length > 0) {
            console.log("Found image in JSON data (product.images)");
            return data.product.images[0].src || data.product.images[0];
          }
        }
      } catch (e) {
        // Skip this JSON element
      }
    }
  } catch (e) {
    console.log("Error parsing JSON data:", e);
  }

  // 3. Look for product media elements with image URLs in data attributes
  const dataImageElements = document.querySelectorAll('[data-image-id], [data-image], [data-product-image], [data-zoom-image]');
  for (const element of dataImageElements) {
    if (element.tagName === 'IMG' && element.src) {
      console.log("Found image in data-image element:", element.src);
      return element.src.replace('http://', 'https://');
    }
    
    // Check data attributes
    const dataZoom = element.getAttribute('data-zoom-image');
    const dataImg = element.getAttribute('data-image');
    const dataSrc = element.getAttribute('data-src');
    
    if (dataZoom) {
      console.log("Found image in data-zoom-image attribute");
      return dataZoom.replace('http://', 'https://');
    }
    
    if (dataImg) {
      console.log("Found image in data-image attribute");
      return dataImg.replace('http://', 'https://');
    }
    
    if (dataSrc) {
      console.log("Found image in data-src attribute");
      return dataSrc.replace('http://', 'https://');
    }
    
    // Look for nested images
    const imgElement = element.querySelector('img');
    if (imgElement && imgElement.src) {
      console.log("Found nested image in data element");
      return imgElement.src.replace('http://', 'https://');
    }
  }
  
  // 4. Try main featured image selectors - common in most themes
  const featuredSelectors = [
    'img.product__image', 
    '.product__media img',
    '.product-single__media img',
    '.product-single__photo img',
    '.product-featured-img',
    '.product-gallery__image img',
    '#ProductPhotoImg'
  ];
  
  for (const selector of featuredSelectors) {
    const img = document.querySelector(selector);
    if (img && img.src) {
      console.log(`Found image with selector: ${selector}`);
      return img.src.replace('http://', 'https://');
    }
  }
  
  // 5. Look for any image inside common product containers
  const productContainers = document.querySelectorAll(
    '.product, .product__media-wrapper, .product-single__media-wrapper, ' +
    '.product__photos, .product-single__photos, #product-photos, ' +
    '.product-image, .product-images, #product'
  );
  
  for (const container of productContainers) {
    const images = container.querySelectorAll('img');
    for (const img of images) {
      if (img.src && !img.src.includes('icon') && !img.src.includes('loader')) {
        console.log("Found image in product container");
        return img.src.replace('http://', 'https://');
      }
    }
  }
  
  // 6. LAST RESORT: Use hardcoded product image URL based on current page URL
  try {
    const currentPath = window.location.pathname;
    if (currentPath.includes('/products/')) {
      // Extract product handle from URL
      const productHandle = currentPath.split('/products/')[1].split('?')[0].split('#')[0];
      if (productHandle) {
        console.log("Using fallback method with product handle:", productHandle);
        // Create a fallback image URL based on the product handle
        const fallbackUrl = `${window.location.origin}/cdn/shop/products/${productHandle.replace(/[^a-z0-9]/gi, '-')}.jpg`;
        console.log("Fallback image URL:", fallbackUrl);
        return fallbackUrl;
      }
    }
  } catch (e) {
    console.log("Error generating fallback URL:", e);
  }
  
  // 7. ABSOLUTE LAST RESORT: hardcode a demo image URL
  console.log("No product image found, using hardcoded fallback");
  return 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-image.png?v=1530129081';
}

// Make this function globally available
window.getProductImageUrl = getProductImageUrl;
  // Simple category detection
  function detectGarmentCategory(productData) {
  if (!productData) return 'tops';
  
  // Convert all available data to lowercase strings for easier searching
  const title = String(productData.title || '').toLowerCase();
  const productType = String(productData.product_type || '').toLowerCase();
  const tags = Array.isArray(productData.tags) 
    ? productData.tags.map(tag => String(tag).toLowerCase()) 
    : [];
  
  // URL path often contains good category signals
  const path = window.location.pathname.toLowerCase();
  
  // Dictionary of terms for each category
  const categoryTerms = {
    // One-pieces
    'one-pieces': [
      'dress', 'dresses', 'jumpsuit', 'romper', 'one piece', 'onepiece', 
      'one-piece', 'bodysuit', 'overall', 'overalls', 'coverall', 'coveralls', 
      'gown', 'suit'
    ],
    
    // Tops
    'tops': [
      'top', 'shirt', 'shirts', 'blouse', 'tshirt', 't-shirt', 't shirt', 'tee',
      'upper_body', 'jacket', 'hoodie', 'sweater', 'sweatshirt', 'vest', 'coat', 
      'blazer', 'cardigan', 'polo', 'tank', 'tanktop', 'tank top', 'jersey',
      'pullover', 'tunic', 'bra', 'sports bra', 'crop', 'crop top', 'turtle neck',
      'turtleneck', 'mock neck', 'mockneck',
      // Equestrian tops
      'show coat', 'show jacket', 'riding jacket', 'competition coat', 'hunt coat',
      'shadbelly', 'dressage coat', 'riding vest', 'ratcatcher', 'stock tie',
      'sun shirt', 'technical shirt', 'show shirt', 'equestrian shirt', 'riding shirt'
    ],
    
    // Bottoms
    'bottoms': [
      'bottom', 'bottoms', 'pants', 'pant', 'lower_body', 'jeans', 'shorts',
      'skirt', 'skirts', 'leggings', 'trouser', 'trousers', 'slacks', 'capri',
      'capris', 'jean', 'jogger', 'joggers', 'sweatpant', 'sweatpants',
      'track pant', 'track pants', 'culottes', 'chino', 'chinos', 'cargo',
      'cargo pants',
      // Equestrian bottoms
      'breeches', 'breech', 'jodhpurs', 'jodhpur', 'riding pants',
      'riding tights', 'full seat', 'knee patch', 'schooling tight',
      'schooling tights', 'riding jean', 'riding jeans', 'show breeches'
    ]
  };
  
  // Check URL path first - it's often the most reliable indicator
  for (const [category, terms] of Object.entries(categoryTerms)) {
    for (const term of terms) {
      if (path.includes(term)) {
        console.log(`Detected '${category}' from URL path, matching term: "${term}"`);
        return category;
      }
    }
  }
  
  // Check title next
  for (const [category, terms] of Object.entries(categoryTerms)) {
    for (const term of terms) {
      if (title.includes(term)) {
        console.log(`Detected '${category}' from product title, matching term: "${term}"`);
        return category;
      }
    }
  }
  
  // Check product type
  for (const [category, terms] of Object.entries(categoryTerms)) {
    for (const term of terms) {
      if (productType.includes(term)) {
        console.log(`Detected '${category}' from product type, matching term: "${term}"`);
        return category;
      }
    }
  }
  
  // Check tags
  for (const [category, terms] of Object.entries(categoryTerms)) {
    for (const term of terms) {
      if (tags.some(tag => tag.includes(term))) {
        console.log(`Detected '${category}' from product tags, matching term: "${term}"`);
        return category;
      }
    }
  }
  
  // Advanced pattern matching using regular expressions
  if (/breech|jodhpur|riding\s+pant|equestrian\s+pant/i.test(title) || 
      /breech|jodhpur|riding\s+pant|equestrian\s+pant/i.test(productType) ||
      /breech|jodhpur|riding\s+pant|equestrian\s+pant/i.test(path)) {
    console.log(`Pattern match: detected 'bottoms' using regex patterns`);
    return 'bottoms';
  }
  
  if (/show\s+coat|riding\s+jacket|shadbelly|hunt\s+coat|equestrian\s+jacket/i.test(title) ||
      /show\s+coat|riding\s+jacket|shadbelly|hunt\s+coat|equestrian\s+jacket/i.test(productType) ||
      /show\s+coat|riding\s+jacket|shadbelly|hunt\s+coat|equestrian\s+jacket/i.test(path)) {
    console.log(`Pattern match: detected 'tops' using regex patterns`);
    return 'tops';
  }
  
  if (/jumpsuit|bodysuit|one-piece|onepiece|dress|gown|overall/i.test(title) ||
      /jumpsuit|bodysuit|one-piece|onepiece|dress|gown|overall/i.test(productType) ||
      /jumpsuit|bodysuit|one-piece|onepiece|dress|gown|overall/i.test(path)) {
    console.log(`Pattern match: detected 'one-pieces' using regex patterns`);
    return 'one-pieces';
  }
  
  console.log('No specific category detected, defaulting to "tops"');
  return 'tops';
}

  // Simplified initialization function
  function initializeTryOnContainers() {
  console.log("Initializing try-on containers...");
  
  // Look for containers
  const containers = document.querySelectorAll('.try-on-container, .virtual-try-on-container');
  console.log(`Found ${containers.length} try-on containers`);
  
  containers.forEach((container, index) => {
    try {
      console.log(`Setting up container ${index+1}`);
      
      // Get image from data attribute
      let garmentImage = container.dataset.garmentImage;
      if (!garmentImage) {
        garmentImage = getProductImageUrl();
      }
      
      // Get category from data attribute
      let category = container.dataset.garmentCategory;
      if (!category) {
        // Check URL first for strongest category signals
        const path = window.location.pathname.toLowerCase();
        if (path.includes('breech') || path.includes('jodhpur') || 
            path.includes('pant') || path.includes('tight') || 
            path.includes('bottom')) {
          console.log(`Detected 'bottoms' from URL path: "${path}"`);
          category = 'bottoms';
        } else if (path.includes('jacket') || path.includes('coat') || 
                  path.includes('top') || path.includes('shirt')) {
          console.log(`Detected 'tops' from URL path: "${path}"`);
          category = 'tops';
        } else {
          // Fall back to product data
          const productData = getProductData();
          category = productData.detectedCategory || detectGarmentCategory(productData);
        }
      }
      
      // Log what we found
      console.log(`Container ${index+1} using:`, {
        category,
        imageUrl: garmentImage ? (garmentImage.substring(0, 30) + '...') : 'none'
      });
      
      if (garmentImage) {
        // Create new instance of VirtualTryOn
        const instance = new VirtualTryOn(container, garmentImage, category);
        console.log(`Initialized container ${index+1}`);
      } else {
        console.error(`Container ${index+1}: No garment image found`);
        container.style.display = 'none';
      }
    } catch (error) {
      console.error(`Container ${index+1}: Error initializing:`, error);
    }
  });
}

  // Initialize when the document is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      console.log("DOM loaded, initializing virtual try-on...");
      // Wait a moment to ensure all elements are rendered
      setTimeout(initializeTryOnContainers, 500);
    });
  } else {
    // DOM already loaded
    console.log("DOM already loaded, initializing virtual try-on immediately...");
    setTimeout(initializeTryOnContainers, 500);
  }

  // Initialize when Shopify sections are loaded
  document.addEventListener('shopify:section:load', function() {
    console.log("Shopify section loaded, re-initializing virtual try-on...");
    setTimeout(initializeTryOnContainers, 500);
  });

  // Export the class for direct usage
  window.VirtualTryOn = VirtualTryOn;
  
  console.log("Virtual try-on script loaded successfully");
})();